// 获取设备信息
let facilityInfo = uni.getSystemInfoSync();
export const systemInfo = facilityInfo;
